
import Vue from 'vue'
import App from './App.vue'
import "./assets/reset.css"
import i18n from './lang'
import router from './router'
import "@/assets/scss/global.scss"
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

if (!String.prototype.format) {
  String.prototype.format = function() {
    var args = arguments;
    return this.replace(/{(\d+)}/g, function(match, number) {
      return typeof args[number] != 'undefined'
        ? args[number]
        : match
      ;
    });
  };
}


new Vue({
  render: h => h(App),
  i18n,
  router
}).$mount('#app')
